import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHero, SectionHeader } from "../components/ui-parts";

export default function About() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings").then(r => setS(r.data)); }, []);
  return (
    <div data-testid="about-page">
      <PageHero badge="About Us" title="Reviving Sanskrit in Odisha" subtitle={s?.about?.en} />
      <section className="section">
        <div className="container-narrow grid gap-10 md:grid-cols-2">
          <div className="js-card p-8">
            <h3 className="font-heading text-2xl text-[var(--js-primary)]">Vision</h3>
            <p className="text-[var(--js-muted)] mt-3">{s?.vision}</p>
          </div>
          <div className="js-card p-8">
            <h3 className="font-heading text-2xl text-[var(--js-primary)]">Mission</h3>
            <p className="text-[var(--js-muted)] mt-3">{s?.mission}</p>
          </div>
        </div>
      </section>
      <section className="section" style={{ background: "#F1EADD" }}>
        <div className="container-narrow">
          <SectionHeader eyebrow="Multilingual" title="Our story, in every language" description="Choose English, Sanskrit, Hindi or Odia from the language menu to read the entire website in your language." />
        </div>
      </section>
      <section className="section">
        <div className="container-narrow">
          <SectionHeader eyebrow="What we do" title="Our activities" />
          <div className="grid gap-6 md:grid-cols-3">
            {[
              ["Spoken Sanskrit", "Camps and courses to help learners speak Sanskrit confidently."],
              ["Free & Paid Courses", "Structured programmes for beginners and advanced learners."],
              ["Books & Publications", "Printed Sanskrit books and teaching materials."],
              ["District-wise Network", "Volunteers and coordinators in all 30 districts of Odisha."],
              ["Training Programmes", "Teacher training in Sanskrit pedagogy."],
              ["Cultural Programmes", "Workshops, poetry recitals, and cultural events."],
            ].map(([h, p]) => (
              <div key={h} className="js-card p-6">
                <div className="font-heading text-lg text-[var(--js-primary)]">{h}</div>
                <p className="text-sm text-[var(--js-muted)] mt-2">{p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
